import {FormArray, FormBuilder, FormGroup, Validators} from '@angular/forms';
import {Component, OnInit} from '@angular/core';
import {PricingRulesService} from '../../../services/pricing-rules.service';
import {MatDialog, MatDialogRef} from '@angular/material';
import {DialogSharedComponent} from '../../dialog-shared/dialog-shared.component';

@Component({
  selector: 'rule-dialog',
  template: `
        <div class="rule-details modal-content">
          <div class="modal-title bg-primary">
            <h3>{{modalTitle}}</h3>
          </div>
          <div class="modal-body" *ngIf="rule.pid != undefined">
            <form [formGroup]="ruleForm">
                <div fxLayout="column" fxLayout.gt-xs="row">
                    <mat-form-field fxFlex>
                      <input mat-input
                        formControlName="name"
                        placeholder="Rule Name" matInput>
                    </mat-form-field>
                  <mat-form-field>
                    <mat-select placeholder="Templates" (selectionChange)="setChosenRule($event)">
                      <mat-option *ngFor="let template of templates" [value]="template.id">
                        {{ template.name }}
                      </mat-option>
                    </mat-select>
                  </mat-form-field>
                    <div fxFlex>
                      <mat-form-field>
                      <mat-select formControlName="action"
                                  (change)="changeAction($event.value)"
                                  placeholder="Action">
                        <mat-option *ngFor="let rule of rules?.ruleActions" [value]="rule.value">
                          {{ rule.label }}
                        </mat-option>
                      </mat-select>
                      </mat-form-field>
                    </div>
                </div>
                <div fxLayout="column" fxLayout.gt-xs="row">
                    <mat-form-field fxFlex>
                      <input mat-input
                        formControlName="value"
                        placeholder="Amount" matInput>
                    </mat-form-field>
                    <mat-form-field fxFlex *ngIf="ruleForm.get('rule_type').value === 1; else currency" style="width: 80px;">
                      <input mat-input value="%" disabled
                        placeholder="Percent" matInput>
                    </mat-form-field>
                    <ng-template #currency>
                      <mat-form-field fxFlex style="width: 80px;">
                        <input mat-input
                               formControlName="currency"
                               placeholder="Currency" matInput>
                      </mat-form-field>
                    </ng-template>
                    <mat-slider *ngIf="viewRule"
                      min="0"
                      max="1"
                      step="1"
                      value="0"
                      formControlName="rule_type"
                      style="width: 60px;"
                      (change)="pctChange($event)"
                      color="primary">
                    </mat-slider>
                    <label *ngIf="viewRule"> {{pctLabel}} </label>
                </div>
                <div formArrayName="conditions" class="cond-block" *ngIf="ruleForm.controls.conditions.controls.length > 0">
                    <label>Rule Conditions</label>
                    <div class="cond-list-wrap">
                    <div class="cond-list">
                        <div class="cond-item row inline-flex"
                             *ngFor="let condition of ruleForm.controls.conditions.controls; let i=index"
                        >
                            <rule-condition
                                [group]="ruleForm.controls.conditions.controls[i]"
                                [count]="i"
                                [cond]="cond"
                            ></rule-condition>
                            <button mat-icon-button color="warn" (click)="removeCondition(i)"><mat-icon>cancel</mat-icon></button>
                        </div>
                    </div>
                    </div>
                </div>
                <div>
                    <button mat-button color="primary" (click)="addCondition()"><mat-icon>add</mat-icon>Add Condition</button>
                </div>
            </form>
          </div>
          <mat-dialog-actions align="end" *ngIf="rule.pid != undefined">
              <button mat-raised-button color="primary" (click)="saveTemplate()">Save as template</button>
              <button mat-raised-button color="primary" (click)="onSubmit()">Save rule</button>
              <button mat-raised-button color="accent" (click)="dialogRef.close('Yes!')">Cancel</button>
              <button mat-raised-button *ngIf="rule.rid != ''" color="warn" (click)="onDelete()">Delete</button>
          </mat-dialog-actions>

          <div class="modal-body" *ngIf="rule.pid == undefined">
              <p>Chose carrier and product first</p>
          </div>
          <mat-dialog-actions align="end" *ngIf="rule.pid == undefined">
              <button mat-button color="primary" (click)="dialogRef.close('Yes!')">Ok</button>
          </mat-dialog-actions>
        </div>
    `,
  providers: [PricingRulesService]
})

export class RuleDialog implements OnInit {
  rule: any;  // rule = {type: string, pid: string, rule: object}
  rules: any;
  cond: any;
  templates: any;
  modalTitle: string;
  ruleForm: FormGroup;
  pctLabel = 'Plain';
  openWindow(href) {
    window.open(href, '');
    return false;
  }
  viewRule = false;

  constructor(public dialogRef: MatDialogRef<RuleDialog>,
              private _fb: FormBuilder,
              public dialog: MatDialog,
              private pricingRulesService: PricingRulesService) {
    this.ruleForm = this._fb.group({
      type: [''],
      object: [''],
      order: [''],
      name: ['', Validators.required],
      action: ['', Validators.required],
      value: ['', Validators.required],
      rule_type: [0],
      currency: ['SEK', Validators.required],
      conditions: this._fb.array([])
    });
  }
  initCondition(values: any = {}) {
    const val = {
      name: '',
      operator: '',
      value: '',
      logicOperator: ''
    };
    if (Object.keys(values).length > 0) {
      for (const i in values) {
        if (val[i] !== undefined) {
          val[i] = values[i];
        }
      }
    }
    return this._fb.group({
      name: [val.name, Validators.required],
      operator: [val.operator, Validators.required],
      value: [val.value, Validators.required],
      logicOperator: [val.logicOperator, Validators.required]
    });
  }
  addCondition() {
    const control = <FormArray>this.ruleForm.controls['conditions'];
    control.push(this.initCondition({logicOperator: 'AND'}));
  }
  removeCondition(i: number) {
    const control = <FormArray>this.ruleForm.controls['conditions'];
    control.removeAt(i);
  }
  ngOnInit() {
    const ruleConditions = [];
    this.fillFormRule();
    this.modalTitle = 'Add ' + this.rule['type'] + ' rule';
    this.pricingRulesService.getRuleTemplate().subscribe((templates) => {
      this.templates = templates;
    });
    this.pricingRulesService.getPricingRules().subscribe(data => {
    });
    this.changeAction(this.rule['item']['action'] );
  }

  private fillFormRule() {
    const ruleProps = {
      'object_id': this.rule.pid === 'all' ? null : this.rule.pid,
      'name': '',
      'action': '',
      'value': '',
      'rule_type': 0,
      'currency': 'SEK',
      'type': this.rule.type,
      'order': '',
      'conditions': []
    };
    if (typeof this.rule.item == 'object' && Object.keys(this.rule.item).length > 0) {
      ruleProps['name'] = this.rule['item']['name'];
      ruleProps['action'] = this.rule['item']['action'];
      ruleProps['value'] = this.rule['item']['value'];
      ruleProps['rule_type'] = this.rule['item']['rule_type'];
      ruleProps['currency'] = this.rule['item']['currency'];
      ruleProps['order'] = this.rule['item']['order'];
      if (this.rule['item']['conditions'].length > 0) {
        ruleProps['conditions'] = [];
        for (const i in this.rule['item']['conditions']) {
          ruleProps['conditions'].push({
            'name': this.rule['item']['conditions'][i]['name'],
            'operator': this.rule['item']['conditions'][i]['operator'],
            'value': this.rule['item']['conditions'][i]['value'],
            'logic_operator': this.rule['item']['conditions'][i]['logic_operator']
          });
        }
      }
    }
    this.ruleForm.patchValue({
      type: ruleProps.type,
      object: ruleProps.object_id,
      order: ruleProps.order,
      name: ruleProps.name,
      action: ruleProps.action,
      value: ruleProps.value,
      rule_type: ruleProps.rule_type,
      currency: ruleProps.currency,
    });
    for (let j = -1; j < this.ruleForm['controls']['conditions']['controls'].length; j++) {
      this.removeCondition(j);
    }
    this.pctChange({value: ruleProps.rule_type});

    if (ruleProps.conditions.length > 0) {
      for (const i in ruleProps.conditions) {
        const control = <FormArray>this.ruleForm.controls['conditions'];
        const cond = this.initCondition({
          name: ruleProps.conditions[i]['name'],
          operator: ruleProps.conditions[i]['operator'],
          value: ruleProps.conditions[i]['value'],
          logicOperator: ruleProps.conditions[i]['logic_operator']
        });
        control.push(cond);
      }
    }
  }

  getProp(arr: any, val: string): any {
    for (const i in arr) {
      if (arr[i]['value'] === val) {
        return arr[i]['value'];
      } else {
        return null;
      }
    }
  }

  onSubmit() {
    const data = this.prepareRule();
    if (this.ruleForm.valid) {
      if (this.rule['item']['id']) {
        const id = this.rule['item']['id'];
        this.pricingRulesService.setPricingRules(id, data).subscribe((data) => {
          this.dialogRef.close('Yes!');
        });
      } else {
        this.pricingRulesService.createPricingRules(data).subscribe((data) => {
          this.dialogRef.close('Yes!');
        });
      }

    } else {
      const dialogRef = this.dialog.open(DialogSharedComponent,
        {width: '450px', data: { errorType: 'null', header: 'service.checkFields' }});
    }
  }

  private prepareRule() {
    const conditions: any = [];
    if (this.ruleForm['value']['conditions'].length > 0) {
      const cnds = this.ruleForm['value']['conditions'];
      for (const i in cnds) {
        conditions.push({
          'name': cnds[i]['name'],
          'operator': cnds[i]['operator'],
          'value': cnds[i]['value'],
          'logic_operator': cnds[i]['logicOperator']
        });
      }

    }
    const data: any = {
      'object_id': this.ruleForm['value']['object'],
      'name': this.ruleForm['value']['name'],
      'action': this.ruleForm['value']['action'],
      'value': this.ruleForm['value']['value'],
      'rule_type': this.ruleForm.get('rule_type').value,
      'currency': this.ruleForm['value']['currency'],
      'type': this.ruleForm['value']['type'],
      'order': this.ruleForm['value']['order'],
      'conditions': conditions
    };

    switch (this.rule.type) {
      case 'customer':
        data.object_type = 'customer';
        break;
      case 'general':
        data.object_type = 'all';
        break;
      case 'margin':
      case 'campaign':
        data.object_type = 'product';
        break;
      case 'campain':
        data.object_type = 'all';
        break;
    }
    return data;
  }

  onDelete() {
    if (this.rule['item']['id']) {
      const id = this.rule['item']['id'];
      this.pricingRulesService.removePricingRule(id).subscribe((data) => {
        this.dialogRef.close('Yes!');
      });
    }
  }

  changeAction(value) {
    if ( value == '=') {
      this.viewRule = false;
      this.ruleForm.controls['rule_type'].setValue('0');
      this.pctLabel = 'Constant';
    } else {
      this.viewRule = true;
    }
  }

  pctChange({value}) {
    switch (value) {
      case 0:
        this.pctLabel = 'Constant';
        break;
      case 1:
        this.pctLabel = 'Percent';
        break;
    }
  }
  saveTemplate() {
    const data = this.prepareRule();
    data.id = '';
    data.order = 0;
        this.pricingRulesService.saveTemplate(data).subscribe((data) => {
          this.dialogRef.close('Yes!');
        });
  }
  setChosenRule(rule) {
    const index = rule.value - 1;
    const data: any = {
      'object_id': this.templates[index].object_id,
      'name': this.templates[index].name,
      'action': this.templates[index].action,
      'value': this.templates[index].value,
      'rule_type': this.templates[index].rule_type,
      'currency': this.templates[index].currency,
      'type': this.templates[index].type,
      'order': this.templates[index].order,
      'conditions': this.templates[index].conditions ? this.templates[index].conditions : []
    };
    this.rule.item = data;
    this.fillFormRule();
  }

}



// WEBPACK FOOTER //
// ./src/app/components/price-rules/rule-dialog/rule-dialog.component.ts